import { Header, Content } from "@backstage/core-components";
import { Typography } from "@material-ui/core";
import React from "react";

interface Props {}

export const LockOutPage: React.FC<Props> = (): JSX.Element => {
  return (
    <div data-testid="lock-out-page">
      <Header title="Admin Panel" />
      <Content>
        <Typography>
          Sorry, but only administrators can view this page
        </Typography>
      </Content>
    </div>
  );
};
